var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigateFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29246 10.8727C6.68246 10.4827 6.68246 9.85274 6.29246 9.46274L2.41246 5.58274L6.29246 1.70274C6.68246 1.31274 6.68246 0.682741 6.29246 0.292741C5.90246 -0.0972592 5.27246 -0.0972592 4.88246 0.292741L0.292461 4.88274C-0.0975391 5.27274 -0.0975391 5.90274 0.292461 6.29274L4.88246 10.8827C5.26246 11.2627 5.90246 11.2627 6.29246 10.8727Z",
    fill: "#707683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2925 10.8727C12.6825 10.4827 12.6825 9.85274 12.2925 9.46274L8.41246 5.58274L12.2925 1.70274C12.6825 1.31274 12.6825 0.682741 12.2925 0.292741C11.9025 -0.0972592 11.2725 -0.0972592 10.8825 0.292741L6.29246 4.88274C5.90246 5.27274 5.90246 5.90274 6.29246 6.29274L10.8825 10.8827C11.2625 11.2627 11.9025 11.2627 12.2925 10.8727Z",
    fill: "#707683"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateFirst);
export default __webpack_public_path__ + "static/media/navigate-first.5d7282bef9d41ebfb362374bfe87c25f.svg";
export { ForwardRef as ReactComponent };